import { render, staticRenderFns } from "./Mindfulness.vue?vue&type=template&id=72eed063&"
import script from "./Mindfulness.vue?vue&type=script&lang=js&"
export * from "./Mindfulness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports